import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkHOD, checkHOU } from '../../permission-utils/settings';

const ProcedureMenu = () => {
	const [isSupervisor, setIsSuperVisor] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{isSupervisor && (
				<li>
					<Link to="/procedure/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/procedure">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			<li>
				<Link to="/procedure/new-request">
					<div className="icon-w">
						<div className="os-icon os-icon-plus-circle" />
					</div>
					<span>New Procedure</span>
				</Link>
			</li>
			<li>
				<Link to="/procedure/categories">
					<div className="icon-w">
						<div className="os-icon os-icon-plus-circle" />
					</div>
					<span>Categories</span>
				</Link>
			</li>
			<li>
				<Link to="/procedure/resources">
					<div className="icon-w">
						<div className="os-icon os-icon-plus-circle" />
					</div>
					<span>Resources</span>
				</Link>
			</li>
			{isSupervisor && (
				<li>
					<Link to="/report/procedures">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Reports</span>
					</Link>
				</li>
			)}
		</>
	);
};

export default ProcedureMenu;
